import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import Feed from '../components/Feed';
import Page from '../components/Page';
import Pagination from '../components/Pagination';

const IndexTemplate = () => {
  return (
    <Layout title="Zakaria Harti" description="ml">
      <Sidebar isIndex />
      <Page>
        <h2 className="about-h2">About Me</h2>
        <hr />
        <p className="about-p">
          Hello, I am <span className="about-p-highlight">Zakaria</span> , an enthusiastic
          <span className="about-p-highlight">developer</span>, open source <span className="about-p-highlight">maintainer</span>
       </p>
       <p className="about-p">
        A conscientious, fast learner offering the ability to assess an organization’s needs
        and create a complementary, robust web presence. contributing to open
        source projects is my key of success as well as helping other developers.
        I can handle both the frontend and the backend by using modern
        cutting-endge web technologies.
       </p>
       <p className="about-p">I enjoy learning anything about programming I keep myself busy by reading books
          as well as challenging myself to solve any problem I encounter,
       I created some open source projects
       you can check them on my <a href="http://github.com/zakariaharti">github profile</a>
       </p>
       <div>
         <a href="mailto:zakariya.harti@gmail.com">Email Me</a>
       </div>
      </Page>
    </Layout>
  );
};

export default IndexTemplate;
